import React from 'react';
import { Link } from '@amzn/awsui-components-core';

const PartnerFlashbarBanner = () => {
  return (
    <>
      <b>Important:</b> As of March 15, 2026, AWS Partners will no longer have access to AWS
      Prescriptive Guidance (APG) Library and its internal catalog. Partners can continue to access
      external-facing APG Library content through the{' '}
      <Link
        color="inverted"
        external
        target="_blank"
        href="https://aws.amazon.com/prescriptive-guidance/"
      >
        APG website
      </Link>
      . If you would like to retain access to a specific internal-only publication, please download
      a PDF prior to March 15, 2026.
    </>
  );
};

export default PartnerFlashbarBanner;
